exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".OrganisationName{margin-bottom:20px}.OrganisationName .create-dialog-form__group--indent-bottom{margin-bottom:0;width:50%}.OrganisationName .far,.OrganisationName .fas{color:#00adff;cursor:pointer;font-size:20px;margin-left:10px}.OrganisationName .far+.far{margin-left:10px}.OrganisationName .block-update{display:flex;align-items:center;min-width:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/UserOrganisation/components/OrganisationName/style.scss
// module id = 5106
// module chunks = 0